var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-2 ma-sm-12",attrs:{"fluid":""}},[_c('div',{staticClass:"mb-5 text-h5 font-weight-black _light_grey--text"},[_vm._v(_vm._s(_vm.$t('deployApp')))]),_c('iframe',{attrs:{"src":_vm.dashboardUrl,"title":"Dashboard","width":"100%","height":"800","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }